export class ScrollUtil {
    private static readonly scrollPrefix = 'scrollPosition:';
    private static readonly lastBrowseLocationKey = 'lastBrowseLocation';

    public static saveScroll = (key: string, scrollPos: number) => {
        sessionStorage.setItem(`${this.scrollPrefix}${key}`, scrollPos.toString());
    };

    public static getSavedScroll = (key: string): number | null => {
        const raw = sessionStorage.getItem(`${this.scrollPrefix}${key}`);
        if (raw == null) {
            return null;
        }

        const scrollPos = Number(raw);
        return Number.isFinite(scrollPos) ? scrollPos : null;
    };

    public static saveLastBrowseLocation = (location: string) => {
        sessionStorage.setItem(this.lastBrowseLocationKey, location);
    };

    public static getLastBrowseLocation = (): string | null => {
        return sessionStorage.getItem(this.lastBrowseLocationKey);
    };
}
